import { render, staticRenderFns } from "./view-dialog.vue?vue&type=template&id=f8e16f2c&scoped=true&"
import script from "./view-dialog.vue?vue&type=script&lang=js&"
export * from "./view-dialog.vue?vue&type=script&lang=js&"
import style0 from "./view-dialog.vue?vue&type=style&index=0&id=f8e16f2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e16f2c",
  null
  
)

export default component.exports